import { css } from '@emotion/css';
import { noteStyle } from 'Shared/forms/Wrap'
import { addItemAndOpen, StoreRepeater } from 'Shared/forms/StoreRepeater';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { theme } from 'Shared/ThemeProvider';
import { verticalStyle } from 'Shared/backend/Theme';
import { ComponentTitle } from 'Shared/backend/widgets/ComponentTitle';
import { VerticalLayout } from 'Shared/model/Components';
import { optionList } from 'Shared/backend/widgets/ComponentOptions';
import { SeparatedComponentAndSelector } from 'Shared/backend/widgets/SeparatedComponentAndSelector';
import { useLayout } from 'Shared/backend/LayoutProvider';
import { Show } from 'solid-js';
import { repeaterBarStyle } from 'Shared/backend/widgets/SectionList';


export function Vertical(P:VerticalLayout)
{
	const addTileStyle = css(theme().button,{
		alignSelf: 'flex-start'
	});

	const tileStyle = css({
		borderLeft: 'solid 5px #f4f4f4',
		paddingLeft: '1em',
		display: 'flex',
		flexDirection : 'column',
		gap: '0.8em'
	});


	const sw = useStore();
	const lo = useLayout();
	let itemsNode!: HTMLElement;

	const options = optionList(['text'],['popup']);

//XXX maybe use theme or class for align instead? Note too sure how...

	return (
		<div class={css(verticalStyle())}>
			<Show when={lo.layout()}>
				<div class={noteStyle()}>
					This layout places items under one another. It allows items to wrap around images,
					as well as allowing vertical margins to overlap one another.
				</div>
			</Show>

			<StoreRepeater ref={itemsNode} permission='edit' field='items' 
				hideDelete={!lo.layout()}
				renderTitle={i => <ComponentTitle {...i}/>}
				barStyle={repeaterBarStyle}
			>
				{(_item,index) => (
					<StoreProvider {...sw} location={[...sw.location,'items',index]}>
						<div class={tileStyle}>
							<SeparatedComponentAndSelector {...P.items[index]} layout={P.items[index].layout} options={options} />
						</div> 
					</StoreProvider>
				)}
			</StoreRepeater>

			<Show when={lo.layout()}>
				<button class={addTileStyle}
					onClick={() => addItemAndOpen(sw,'items',itemsNode,{layout:'text',type:'title'})}
				>
					<i class='fas fa-plus'/> Add item
				</button>
			</Show>
		</div>
	);
}

